import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-vendor-account',
  templateUrl: './add-vendor-account.component.html',
  styleUrls: ['./add-vendor-account.component.css'],
})
export class AddVendorAccountComponent {
  inviteForm: FormGroup;
  profileForm: FormGroup;
  tab: 'invite' | 'profile' = 'invite';

  constructor(
    private fb: FormBuilder,
    private readonly api: ApiService,
    private readonly toastr: ToastrMsgService,
    private readonly router: Router
  ) {
    this.inviteForm = this.fb.group({
      company_name: ['', Validators.required],
      primary_contact_email: ['', [Validators.required, Validators.email]],
      primary_contact_name: [''],
      primary_contact_phone: [''],
    });
    this.profileForm = this.fb.group({
      company_name: ['', Validators.required],
      gst_number: [''],
      pan_number: [''],
      address_line_1: [''],
      address_line_2: [''],
      city: [''],
      state: [''],
      postal_code: [''],
      country: [''],
      primary_contact_name: [''],
      primary_contact_email: ['', Validators.email],
      primary_contact_phone: [''],
      availability_status: ['available'],
    });
  }

  submitInvite(): void {
    if (this.inviteForm.invalid) {
      this.inviteForm.markAllAsTouched();
      return;
    }
    this.api.inviteVendorAccount(this.inviteForm.value).subscribe({
      next: () => {
        this.toastr.success('Vendor invited — credentials emailed.');
        this.router.navigate(['/home/vendor/list']);
      },
      error: (err) => this.toastr.error(err?.error?.message || 'Invite failed'),
    });
  }

  submitProfile(): void {
    if (this.profileForm.invalid) {
      this.profileForm.markAllAsTouched();
      return;
    }
    this.api.createVendorAccount(this.profileForm.value).subscribe({
      next: () => {
        this.toastr.success('Vendor profile created');
        this.router.navigate(['/home/vendor/list']);
      },
      error: (err) => this.toastr.error(err?.error?.message || 'Create failed'),
    });
  }
}
